function MyDataWrapperMeedyVO(physicianDetails, user, medicalPost, medicalPostAccounting) {

    this.physicianDetails = physicianDetails;
    this.user = user;
    this.medicalPost = medicalPost;
    this.medicalPostAccounting = medicalPostAccounting;

    if (_.isUndefined(this.physicianDetails)) {
        this.physicianDetails = new PhysicianDetailsMeedyVO();
    }
    if (_.isUndefined(this.user)) {
        this.user = new UserMeedyVO();
    }
    if (_.isUndefined(this.medicalPost)) {
        this.medicalPost = new MedicalPostMeedyVO();
    }
    if (_.isUndefined(this.medicalPostAccounting)) {
        this.medicalPostAccounting = new MedicalPostAccountingMeedyVO();
    }

    var _typeContext = {
        physicianDetails : PhysicianDetailsMeedyVO,
        user: UserMeedyVO,
        medicalPost: MedicalPostMeedyVO,
        medicalPostAccounting : MedicalPostAccountingMeedyVO
    };

    this._getType = function(property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
